
import clienteAxios from "../config/axios";

export const getAllEqpg = async () => {
    return clienteAxios.get('/eqpg');
};
export const addEqpg = async (eqpg) => {
    return await clienteAxios.post('/eqpg',{eqpg});
}
export const updateEqpg = async (eqpg) => {
    return await clienteAxios.put(`eqpg/${eqpg.id}`,{eqpg});
}
export const deleteEqpg = async (eqpgID,tDocID) => {
    return await clienteAxios.delete(`eqpg/${eqpgID}`,{data: {tDocID:tDocID}});
}
